import 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GameSettings, FormSettings, SettingsResult } from '../models/game-settings.model';
import { Card, CardPublished } from '../models/card.model';
import { environment } from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'content-type': 'application/json' })
};

export interface ApiResponse {
  message: any
}

@Injectable()
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {
    console.log('apiUrl:', this.apiUrl);
  }

  updateSettings(settings) {
    return this.httpClient.post<SettingsResult>(this.apiUrl + 'game-session', settings, httpOptions);
  }

  getSettings(sessionCode) {
    return this.httpClient.get<SettingsResult>(this.apiUrl + 'game-session/' + sessionCode);
  }

  getCards() {
    return this.httpClient.get<Card[]>(this.apiUrl + 'cards');
  }

  publish(uuid: string, cardPublished: CardPublished) {
    return this.httpClient.post<CardPublished[]>(this.apiUrl + 'publish', {uuid: uuid, publishedCard: cardPublished}, httpOptions);
  }

  unpublish(uuid: string, publishedCardId: number) {
    return this.httpClient.post<CardPublished[]>(this.apiUrl + 'unpublish', {uuid: uuid, id: publishedCardId}, httpOptions);
  }

  published(sessionCode: string) {
    return this.httpClient.get<CardPublished[]>(this.apiUrl + 'published/' + sessionCode);
  }

  getPDFBaseUrl() {
    return this.apiUrl + 'pdfs/';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts